import React from "react"
import logo from "../assets/logo_big.jpg"
import weixin from "../assets/weixin.png"
import {Link} from "react-router-dom"
import {Icon, Popover} from "antd"

const Footer = ({
                  pathname
                }) => {
  return <div className="header">
    <div className="logo">
      <img alt='logo' src={logo}/>
      <div className="social-contact">
        <ul>
          <li>
            <a href="https://weibo.com/csnbg" target="_blank"><Icon type="weibo"/>&nbsp;微博</a>
          </li>
          <li>

            <Popover
              content={<img style={{width: 150}} src={weixin}/>}
              trigger="click"
            >
              <a><Icon type="wechat"/>&nbsp;微信</a>
            </Popover>
          </li>
        </ul>
      </div>
    </div>
    {
      pathname !== '/' && <ul className="menus">
        <li>
          <a href="http://www.csnbgsh.cn/">进入官网</a>
        </li>
        <li className={pathname.indexOf('/group-apply') === 0 && 'active'}>
          <Link to="/group-apply">团队预约</Link>
        </li>
        <li className={pathname.indexOf('/ticket') === 0 && 'active'}>
          <Link to="/ticket/guide">网上售票</Link>
        </li>
      </ul>
    }
  </div>
}

export default Footer
